// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604160536/js/" + chunkId + "." + {"44":"49537ac5","225":"84d13785","481":"093b0995","486":"ec4ac1f2","770":"2946099a"}[chunkId] + ".0.7518550837857132.chunk.js";
};